import React from 'react';
import PropTypes from 'prop-types';
import CompanyEditRow from './CompanyEditRow';
import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';
import OnTraccrSwitch from '../common/inputs/OnTraccrSwitch';

export default function CheckRows({
  data,
  onChange = () => null,
  isChecked,
  checkBoxDisabled = () => false,
  getMultiView = () => null,
  getView = () => null,
}) {
  return data.map((datum, index) => {
    const {
      key, title, helpText, multi = false, divider = true, style, useSwitch = false,
    } = datum;
    const Input = useSwitch ? OnTraccrSwitch : OnTraccrCheckbox;
    return (
      <CompanyEditRow
        key={key}
        title={title}
        helpText={helpText}
        divider={divider}
        style={style}
      >
        {multi
          ? getMultiView()
          : getView(index) || (
          <Input
            onChange={() => onChange(datum)}
            style={{ marginRight: useSwitch ? 40 : 56 }}
            value={isChecked(datum)}
            disabled={checkBoxDisabled(datum)}
          />
          )}

      </CompanyEditRow>
    );
  });
}

CheckRows.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    helpText: PropTypes.string,
    multi: PropTypes.bool,
    divider: PropTypes.bool,
    style: PropTypes.shape({}),
  })).isRequired,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool.isRequired,
  checkBoxDisabled: PropTypes.func,
  getMultiView: PropTypes.func,
  getView: PropTypes.func,
};

CheckRows.defaultProps = {
  onChange: () => null,
  checkBoxDisabled: () => false,
  getMultiView: () => null,
  getView: () => null,
};
